import StoreUtil from "../store.util.js";
const mutations = {
    SET_ALL_GROUPS(state, payload) {
        state.groupList = StoreUtil.updateState(state.groupList, payload);
      },
};

export default mutations;
